import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Operations.css';

function WarehouseSale() {
  const { sku } = useParams();
  const navigate = useNavigate();
  const [quantity, setQuantity] = useState('');
  const [totalInventory, setTotalInventory] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchInventory();
  }, [sku]);

  const fetchInventory = async () => {
    try {
      const response = await axios.get(`/api/ops/inventory/${sku}`);
      const total = response.data.reduce((sum, inv) => sum + inv.quantity, 0);
      setTotalInventory(total);
    } catch (error) {
      console.error('Failed to fetch inventory:', error);
    }
  };

  const handleWarehouseSale = async (e) => {
    e.preventDefault();
    setError('');

    const qty = parseInt(quantity);
    if (isNaN(qty) || qty < 1) {
      setError('Please enter a valid quantity');
      return;
    }

    if (qty > totalInventory) {
      setError(`Quantity cannot exceed available inventory (${totalInventory})`);
      return;
    }

    setLoading(true);

    try {
      // Get authenticated user info from session
      const userJson = sessionStorage.getItem('ops_user');
      const user = userJson ? JSON.parse(userJson) : null;
      const userName = user ? `${user.first_name} ${user.last_name}` : 'Mobile User';

      await axios.post('/api/ops/warehouse-sale', {
        sku,
        quantity: qty,
        adjusted_by: userName
      });

      alert(`${qty} units moved to warehouse sale successfully!`);
      navigate(`/ops/${sku}`);
    } catch (error) {
      console.error('Warehouse sale error:', error.response?.data);
      setError(error.response?.data?.error || 'Failed to process warehouse sale');
      setLoading(false);
    }
  };

  return (
    <div className="ops-page">
      <div className="ops-page-header">
        <Link to={`/ops/${sku}`} className="back-button">← Back</Link>
        <h1>Warehouse Sale</h1>
        <div className="sku-label">{sku}</div>
      </div>

      <form onSubmit={handleWarehouseSale} className="transfer-form">
        {error && <div className="error-message">{error}</div>}

        <div className="info-box">
          <div className="info-label">Available Inventory</div>
          <div className="info-value">{totalInventory} units</div>
        </div>

        <div className="form-group">
          <label htmlFor="quantity">Quantity to Move to Warehouse Sale</label>
          <input
            type="number"
            id="quantity"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            min="1"
            max={totalInventory > 0 ? totalInventory : undefined}
            required
            className="form-control"
            placeholder="Enter quantity"
          />
          {totalInventory > 0 && (
            <small className="form-help">Max available: {totalInventory}</small>
          )}
        </div>

        <div className="info-box warning">
          <strong>Note:</strong> This will create an inventory adjustment removing items from inventory (Account #5181 "Inventory - Liquidation")
        </div>

        <button
          type="submit"
          disabled={loading}
          className="submit-button"
        >
          {loading ? 'Processing...' : 'Move to Warehouse Sale'}
        </button>
      </form>
    </div>
  );
}

export default WarehouseSale;
